import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import Http from '../../../Http'

export default class MarcarRetraso extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'banco/one', saveUrl: 'retraso-embarque/save', backUrl: '' },
      new Form([
        Form.Field('select', 'id_motivo_atraso', 'Motivo de Atraso', '', [Validators.required], 12),
        Form.Field('textarea', 'descripcion', 'Descripcion', '', [Validators.required], 12),
      ], ['Guardar'], ''), this.formData
    )

    this.setState({ id_embarque: this.props.id });
  }

  formData = async (form) => {
    const Res = await Http.get('retraso-embarque/form');

    if (!Res.error) {
      let motivos = Form.FieldOptions(form, 'id_motivo_atraso', Res.data.motivos, 'id', 'motivo_nombre');
      return motivos;
    }
  }

  onSubmit = async (i, vals) => {
    const { id_embarque } = this.state;
    this.setState({ loading: true });
    vals.id_embarque = id_embarque;
    var Res = await Http.post(`${this.config.saveUrl}`, vals);

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      if (this.props.reset) {
        this.setState({ FormData: Form.Reset(this.state.FormData) });
      }
      this.props.onSave();
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
    }

  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}
